module.exports = __webpack_public_path__ + "static/water_glacier8-2cbefd0fda00a0a3ff009821f5ab6ad4.jpg";